import React, { useState, useEffect } from "react"
import { Container } from 'react-bootstrap';
import parse from 'html-react-parser';
import loadable from '@loadable/component'
import { navigate } from "@reach/router"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import SearchResultInputBox from "../../predictive-search/SearchResultBoxHeader"
import { hyphenToCaptilize, QueryList } from "../../utils/property-search"
import Close from "../../../images/home-close.svg"
import GoogleReviewCount from "../../GoogleReviewCount/GoogleReviewCount"


import { inViewOptions, contentItemStagger, contentItem, fadeInFromTop } from '../../utils/animation';

import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";


// styles
import ScrollAnimation from 'react-animate-on-scroll';
import "./Banner.scss"
// markup

const LoqateAddress = loadable(() => import('../../forms/elements/address-search-instant'))
const TrustPilotWidget = loadable(() => import('../../TrustPilotWidget'))

const HomeBanner = (props) => {
  const bannerImages = Array.isArray(props.Banner_Image)
    ? props.Banner_Image
    : props.Banner_Image ? [props.Banner_Image] : [];

  // SSR renders index 0 so LCP image is in the static HTML.
  // After mount we swap to a random pick — does not affect PageSpeed score.
  const [bannerImg, setBannerImg] = useState(null);
  const [imageLoading, setImageLoading] = useState(true);

  const [bannercta, setBannerCTA] = useState(true);
  const [valuation, setValuation] = useState(false);
  const [propertysearch, setPropertySearch] = useState(false);
  const [areaVal, setAreaVal] = useState('')
  const queryList = QueryList();

  function OpenValuation() {
    setBannerCTA(false)
    setValuation(true)
    setPropertySearch(false)

  }

  function OpenPropertySearch() {
    setBannerCTA(false)
    setValuation(false)
    setPropertySearch(true)

  }

  function CloseSearch() {
    setBannerCTA(true)
    setValuation(false)
    setPropertySearch(false)

  }


  // Valuation — native DOM replaces jQuery
  function getInputVal(name) {
    const el = document.querySelector(`input[name="${name}"]`)
    return el ? el.value : ''
  }

  function saveValuationToStorage() {
    localStorage.setItem('instant-address-full', getInputVal('in_address'))
    localStorage.setItem('instant-address',      getInputVal('in_address_home'))
    localStorage.setItem('instant-postcode',     getInputVal('in_postcode'))
    localStorage.setItem('instant-stno',         getInputVal('instant_stno'))
    localStorage.setItem('instant-street',       getInputVal('instant_street'))
    localStorage.setItem('instant-district',     getInputVal('instant_district'))
    localStorage.setItem('instant-post_town',    getInputVal('instant_post_town'))
    localStorage.setItem('instant-county',       getInputVal('instant_county'))
    localStorage.setItem('instant-postcode',     getInputVal('instant_postcode'))
    localStorage.setItem('hometrack_add',        getInputVal('hometrack_add'))
  }

  function onClickBuy(e) {
    saveValuationToStorage()
    navigate(`/sell-your-property/property-valuation/instant-valuation`)
  }

  function onClickRent(e) {
    saveValuationToStorage()
    navigate(`/sell-your-property/property-valuation/instant-valuation`)
  }
  // Valuation


  // Property Search 

  function onClickPropertyBuy(val) {
    let url = "/property/for-sale/";
    var searcValue = val.split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase()

    if (searcValue !== "") {
      url += "in-" + searcValue + "/radius-3-miles/"
    } else {
      url += "in-kent/"
    }

    localStorage.setItem('searchValue', searcValue ? searcValue : 'kent');
    localStorage.setItem('searchValueFull', searcValue ? searcValue : 'kent');
    localStorage.setItem('searchValueFullName', val ? val : 'kent');
    navigate(url);
    // window.location.href = url;
  }
  function onClickPropertyRent(val) {
    let url = "/property/to-rent/";
    var searcValue = val.split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase()

    if (searcValue !== "") {
      url += "in-" + searcValue + "/"
    } else {
      url += "in-kent/"
    }

    localStorage.setItem('searchValue', searcValue ? searcValue : 'kent');
    localStorage.setItem('searchValueFull', searcValue ? searcValue : 'kent');
    localStorage.setItem('searchValueFullName', val ? val : 'kent');

    navigate(url);
    // window.location.href = url;
  }

  // Property Search


  useEffect(() => {
    setBannerCTA(true)
    setValuation(false)
    setPropertySearch(false)
    //setImageLoading(true)
    const randomIndex = Math.floor(Math.random() * bannerImages.length)
    setBannerImg(bannerImages[randomIndex])
  }, []);

  const handleImageLoad = () => {
    setImageLoading(false)
  }

  return (

    <React.Fragment>
      <div className="main-banner components--Home--Banner-Banner">
        <div className="main-banner-embed">
          {/* <video width="100%" height="100%" autoPlay playsInline loop muted className="video-banner">
            <source src={BannerVideo} type="video/mp4" />
          </video> */}
          {/* <img src={BannerImage} alt="Banner Image" className="d-none d-lg-block"/>
          <img src={BannerImageMobile} alt="Banner Image" className="d-block d-lg-none mobile-banner" /> */}
          {/* {bannerimageVal !== "ggfx" ? <StaticImage src="../../../images/area-guide/home-banner.jpg" layout="fullWidth" placeholder="blurred" formats={["webp"]} alt="banner" quality="65" className="img-fluid banner_img" /> :  */}

          {/* Loading Spinner */}
          {imageLoading && (
            <motion.div
              className="banner-loader"
              initial={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="spinner-container">
                <motion.div
                  className="spinner"
                  animate={{ rotate: 360 }}
                  transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
                />
              </div>
            </motion.div>
          )}

          {bannerImg && (
            bannerImg.url_sharp
              ? <GatsbyImage
                  image={getImage(bannerImg.url_sharp)}
                  alt={bannerImg.alternativeText || ''}
                  loading="eager"
                  fetchpriority="high"
                  placeholder="none"
                  className="banner_img"
                  onLoad={handleImageLoad}
                />
              : <img
                  src={bannerImg.url}
                  alt={bannerImg.alternativeText || ''}
                  loading="eager"
                  fetchpriority="high"
                  className="banner_img"
                  onLoad={handleImageLoad}
                />
          )}
          {/* {areaimages[0] &&
            <ImageTransform
              imagesources={areaimages[0].Banner_Image.url}
              renderer="srcSet"
              imagename="area-guides.Banner_Image.details"
              attr={{ alt: '', class: '' }}
              imagetransformresult={processedImages}
              id={areaimages[0].id}
            />
            // <Img fluid={areaimages[0].Banner_Image.url_sharp.childImageSharp.fluid} alt={areaimages[0].Banner_Image.alternativeText} />
          } */}

          {/* {props.Banner_Image &&
        <Img fluid={props.Banner_Image.url_sharp.childImageSharp.fluid} alt={props.Banner_Image.alternativeText} />
      } */}
        </div>
        <div className="main-banner-content">
          <Container>
            <InView  {...inViewOptions}>
              {({ ref, inView }) => (
                <motion.div
                  className="banner-text"
                  ref={ref}
                  initial="hidden"
                  animate={inView ? "visible" : "hidden"}
                  variants={contentItemStagger}

                >

                  <motion.div key={1} custom={1} variants={fadeInFromTop} className="banner-title">
                    {parse(props.Banner_Content)}
                  </motion.div>

                  <div className="home-banner-search" id="home-banner-search">
                    {bannercta &&
                      <div className="btn-wrap" id="home-banner-search-cta">
                        <motion.div key={2} custom={2} variants={fadeInFromTop} className="btn-width-cta">
                          <a href="javascript:void(0)" class="btn btn-secondary" onClick={() => OpenValuation()}>
                            {props.Banner_CTA_1_Label_Heading && <span>{props.Banner_CTA_1_Label_Heading}</span>}
                            {props.Banner_CTA_1_Label}
                          </a>
                        </motion.div>
                        {props.Banner_CTA_2_Label &&
                          <motion.div key={3} custom={3} variants={fadeInFromTop} className="btn-width-cta">
                            <a href="javascript:void(0)" class="btn" onClick={() => OpenPropertySearch()}>
                              {props.Banner_CTA_2_Label_Heading && <span>{props.Banner_CTA_2_Label_Heading}</span>}
                              {props.Banner_CTA_2_Label}
                            </a>
                          </motion.div>
                        }

                      </div>
                    }
                      {/* {bannercta &&
                      <div className="btn-wrap" id="home-banner-search-cta">
                        <div className="btn-width-cta">
                          <a href="/getmoving" class="btn">
                          Find out more
                          </a>
                        </div> 
                      </div>
                    } */}
                    {valuation &&
                       <ScrollAnimation animateIn="fadeInUp">
                        <div className="home-banner-search-valuation" id="home-banner-search-valuation">
                          <LoqateAddress />
                          <div className="btn-wrap">
                            <button class="btn btn-secondary" onClick={() => onClickBuy()}>
                              <span>I want to</span>Sell
                            </button>
                            <button class="btn btn-primary" onClick={() => onClickRent()}>
                              <span>I want to</span>Let
                            </button>
                            <img src={Close} className="close" alt="" onClick={() => CloseSearch()} />
                          </div>
                        </div>
                      </ScrollAnimation>
                    }
                    {propertysearch &&
                      <ScrollAnimation animateIn="fadeInUp">
                        <div className="home-banner-search-property" id="home-banner-search-property">
                          <div class="text form-group form-group">
                            <div class="custom-float">
                              <SearchResultInputBox
                                value={areaVal !== 'kent' ? hyphenToCaptilize(areaVal) : ''}
                                setValue={(searchValue) => {
                                  // refine(removeSpecialChar(searchValue))
                                  setAreaVal(searchValue)
                                }}
                                placeHolder={`Choose town or area`}
                                areaList={queryList.areaList}
                                additionalclass="address address-search"
                              />
                            </div>
                          </div>
                          <div className="btn-wrap">
                            <button type='button' class="btn btn-secondary" onClick={() => onClickPropertyBuy(areaVal)}>
                              <span>I’d like to</span>Buy
                            </button>
                            <button type='button' class="btn" onClick={() => onClickPropertyRent(areaVal)}>
                              <span>I’d like to</span>Rent
                            </button>
                            <img src={Close} alt="" onClick={() => CloseSearch()} />
                          </div>

                        </div>
                      </ScrollAnimation>
                    }
                  </div>

                </motion.div>
              )}
            </InView>


            {props.Show_Reviews &&
              <InView  {...inViewOptions}>
                {({ ref, inView }) => (
                  <motion.div
                    className="rating-block"
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={contentItemStagger}

                  >
                    <motion.div variants={contentItem} className="trustpilot-review">
                      <TrustPilotWidget />
                    </motion.div>

                    <div className="land-banner-review">
                    <motion.div variants={contentItem} className="google-review">
                      <GoogleReviewCount />
                      {/* <div className="review-logo">
                        <img src={GoogleReviews} alt="" width="74" />
                      </div>
                      <p>
                        <strong>4.5 out of 5 </strong>
                        based on 64 reviews
                      </p> */}
                    </motion.div>
                    </div>
                  </motion.div>
                )}
              </InView>
            }




          </Container>
        </div>


      </div>
    </React.Fragment>
  )
}

export default HomeBanner
